import { Rpc } from '../rpc';
import { RpcOutbound } from '../rpc-outbound';
import { RpcOutboundClient } from '../rpc-outbound-client';
import { RpcDialogOverlayData, RpcDialogOverlayResult, RpcOverlayCloseKey } from './rpc-overlay-model';

export class RpcOverlayCloseClient {
    /**
     * The RPC overlay close command.
     * @param rpc the rpc service.
     * @param data the CredSSP operation result object.
     * @param outbound the outbound channel to call. @optional
     * @return Promise<RpcDialogOverlayResult> the promise object of dialog overlay result.
     */
    public static overlayClose(rpc: Rpc, data: RpcDialogOverlayData): Promise<RpcDialogOverlayResult>;
    public static overlayClose(rpc: Rpc, data: RpcDialogOverlayData, outbound?: RpcOutbound): Promise<RpcDialogOverlayResult>;
    public static overlayClose(rpc: Rpc, data: RpcDialogOverlayData, outbound?: RpcOutbound): Promise<RpcDialogOverlayResult> {
        if (outbound) {
            return RpcOutboundClient.callOutbound(
                rpc.rpcManager.rpcChannel,
                outbound,
                RpcOverlayCloseKey.command,
                RpcOverlayCloseKey.version,
                data
            );
        } else {
            return RpcOutboundClient.call(rpc, RpcOverlayCloseKey.command, RpcOverlayCloseKey.version, data);
        }
    }
}
